import upperFirst from 'lodash/upperFirst'

export default (status) => upperFirst(status.replace('_', ' '))



// WEBPACK FOOTER //
// ./src/helpers/pin-status.js